<template>
  <div>
    <h2>Задачи</h2>

    <!-- add button -->
    <b-row class="mt-5 mb-2">
      <b-col>
        <b-button variant="primary" class="mb-1 mr-1" :to="{ name: 'TasksKanban'}">
          <b-icon-kanban></b-icon-kanban>
        </b-button>
        <b-button class="mb-1 mr-1" :to="{ name: 'TasksWeek' }">Неделя</b-button>
        <b-button class="mb-1" v-on:click="onCreateButton">Добавить</b-button>

        <task-modal :form="form" :isUpdate="isUpdate" @refresh="$refs.table.refresh()"></task-modal>
      </b-col>
    </b-row>

    <!-- Фильтр -->
    <b-card class="bg-light mb-3">
      <b-form size="sm">
        <b-form-row>
          <b-col>
            <b-form-group label="Ответственный:" label-size="sm">
              <multi-select
                v-model="taskFilter.responsible"
                :options="optionsResponsible"
                :searchable="true"
                :loading="isLoadingResponsible"
                :internal-search="false"
                :hide-selected="true"
                track-by="last_name"
                label="last_name"
                placeholder="Введите имя для поиска"
                selectLabel="Enter чтобы выбрать"
                :multiple="false"
                :allowEmpty="true"
                @search-change="asyncFindResponsible"
              >
                <template slot="option" slot-scope="props">{{ contactFullName(props.option) }}</template>
                <template slot="noOptions">Начните вводить имя</template>
                <template slot="singleLabel" slot-scope="{ option }">{{ contactFullName(option) }}</template>
                <span slot="noResult">Не найдено</span>
                <template slot="beforeList">
                  <b-button v-if="taskFilter.responsible" block @click="taskFilter.responsible = ''" class="rounded-0">
                    Очистить
                  </b-button>
                </template>
              </multi-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Статус:" label-size="sm">
              <b-form-select
                v-model="taskFilter.status"
                :options="expireOptions"
                class="mb-3"
                value-field="name"
                text-field="title"
                disabled-field="notEnabled"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <b-button type="button" @click="initFilterData" size="sm">Сбросить фильтр</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>

    <!-- table -->
    <div>
      <b-table striped hover small show-empty ref="table"
               :items="tableDataProvider"
               :fields="fields"
               :busy.sync="isBusy"
               empty-text="Нет задач"
               empty-filtered-text="Не найдено"
               :per-page="perPage"
               :current-page="currentPage">
        <template v-slot:cell(object)="data">
          <div v-if="data.item.source==='company'">Компания:
            <router-link :to="{ name: 'Company', params: { id: data.item.company.id }}">{{
                data.item.company.title
              }}
            </router-link>
          </div>
          <div v-if="data.item.source==='contact'">Контакт:
            <router-link :to="{ name: 'Contact', params: { id: data.item.contact.id }}">
              {{ contactFullName(data.item.contact) }}
            </router-link>
          </div>
          <div v-if="data.item.source==='deal'">Сделка:
            <router-link :to="{ name: 'Deal', params: { id: data.item.deal.id }}">{{
                data.item.deal.title
              }}
            </router-link>
          </div>
        </template>
        <template v-slot:cell(content)="data">
          <pre class="hidden-overflow">{{ data.value }}</pre>
        </template>
        <template v-slot:cell(responsible)="data">
          {{ contactFullName(data.value) }}
        </template>
        <template v-slot:cell(created_at)="data">
          {{
            (new Date(Date.parse(data.value))).toLocaleString([], {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric'
            })
          }}
        </template>
        <template v-slot:cell(due_date)="data">
          <span :class="(Date.parse(data.value) < Date.now() && data.item.status==='todo')?'text-danger':''">{{
              data.value ? (new Date(Date.parse(data.value))).toLocaleString([], {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
              }) : ''
            }}</span>
        </template>
        <template v-slot:cell(status)="data">
          <h6>
            <b-badge :variant="data.value==='todo'?'primary':'success'">
              {{ data.value === "todo" ? "К выполнению" : "Готово" }}
            </b-badge>
            <b-badge variant="danger" v-if="(Date.parse(data.item.due_date) < Date.now() && data.item.status==='todo')">
              Просрочено
            </b-badge>
          </h6>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button-group>
            <b-button v-on:click="show(data.item.id)" variant="primary" size="sm">
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-on:click="remove(data.item.id)" variant="danger" size="sm">
              <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <b-pagination align="center"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="my-table"
      ></b-pagination>
    </div>

  </div>
</template>
<script>
import MultiSelect from 'vue-multiselect';
import commonMixin from '../mixins/common';
import 'vue2-datepicker/index.css';
import TaskModal from "../components/TaskModal";

export default {
  name: "Tasks",
  mixins: [commonMixin],
  components: {TaskModal, MultiSelect},
  data() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      taskFilter: {
        query: '',
        responsible: '',
        status: ''
      },
      expireOptions: [
        {
          title: "Все задачи",
          name: ""
        },
        {
          title: "Просроченные",
          name: "expired"
        },
        {
          title: "На сегодня",
          name: "today"
        },
        {
          title: "На завтра",
          name: "tomorrow"
        },
        {
          title: "На неделю",
          name: "week"
        },
        {
          title: "Завершенные",
          name: "done"
        },
      ],
      // momentFormat: {
      //   //[optional] Date to String
      //   stringify: (date) => {
      //     return date ? moment(date).format('LL') : ''
      //   },
      //   //[optional]  String to Date
      //   parse: (value) => {
      //     return value ? moment(value, 'LL').toDate() : null
      //   },
      //   //[optional] getWeekNumber
      //   getWeek: (date) => {
      //     return // a number
      //   }
      // },
      sourceOptions: [
        {value: 'deal', text: 'Сделка'},
        {value: 'company', text: 'Компания'},
        {value: 'contact', text: 'Контакт'},
      ],
      isUpdate: false,
      isBusy: false,
      isBusyButton: false,
      isLoading: false,
      isLoadingDeal: false,
      isLoadingResponsible: false,
      isLoadingContact: false,
      isLoadingCompany: false,
      totalRows: 1,
      errorResult: null,
      messageResult: '',
      perPage: 20,
      currentPage: 1,
      error: false,
      message: '',
      fields: [
        {key: 'content', label: 'Задача'},
        {key: 'object', label: 'Объект'},
        {key: 'responsible', label: 'Ответственный'},
        {key: 'status', label: 'Статус'},
        {key: 'due_date', label: 'Срок'},
        {key: 'created_at', label: 'Создано'},
        {key: 'actions', label: 'Действия'}
      ],
      items: [],
      optionsResponsible: [],
      optionsDeal: [],
      optionsContact: [],
      optionsCompany: [],
      statusOptions: [
        {value: 'todo', text: 'К выполнению'},
        {value: 'done', text: 'Готово'},
      ],
      form: {
        due_date: '',
        content: '',
        responsible: null,
        company: null,
        deal: null,
        contact: null,
        source: null,
        id: null,
        status: 'todo'
      }
    }
  },
  created() {
    if (localStorage.getItem('taskFilterLocal')) {
      try {
        this.taskFilter = JSON.parse(localStorage.getItem('taskFilterLocal'));
      } catch (e) {
        console.error(e)
        this.taskFilter.query = ''
        this.taskFilter.responsible = ''
        this.taskFilter.status = ''
      }
    }
  },
  mounted() {
    let id = this.$route.hash.replace(/^#+/g, '');
    if (id) {
      this.show(id);
    }
  },
  watch: {
    'taskFilter': {
      handler: function (data) {
        if (data) {
          localStorage.setItem('taskFilterLocal', JSON.stringify(data));
          this.$refs.table.refresh();
        }
      },
      immediate: false,
      deep: true
    },
  },
  methods: {
    initFilterData() {
      this.taskFilter.query = ''
      this.taskFilter.responsible = ''
      this.taskFilter.status = ''
    },
    onCreateButton() {
      this.form.due_date = '';
      this.form.content = '';
      this.form.responsible = null;
      this.form.company = null;
      this.form.deal = null;
      this.form.contact = null;
      this.form.source = null;
      this.form.id = null;
      this.form.status = 'todo';
      this.isUpdate = false;

      this.$bvModal.show('task-modal');
    },
    createTask(evt) {
      evt.preventDefault();
      this.error = false;
      this.isBusyButton = true;
      let promise = null;
      if (this.isUpdate) {
        promise = this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + this.form.id, JSON.stringify(this.form));
      } else {
        promise = this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/tasks/', JSON.stringify(this.form));
      }

      return promise.then((response) => {
        this.isBusyButton = false;
        if (response) {
          if (response.data.error === false) {
            this.error = false;
            this.$bvModal.hide('task-modal');
            this.$refs.table.refresh();
          } else {
            this.error = true;
            this.message = response.data.message;
          }
        }
      })
    },
    submitSearch(evt) {
      evt.preventDefault();
      this.$refs.table.refresh();
    },
    tableDataProvider(ctx) {
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/', {
        params: {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          query: this.taskFilter.query,
          responsible: this.taskFilter.responsible.id,
          status: this.taskFilter.status,
        }
      });

      return promise.then(response => {
        this.items = response.data.tasks;
        this.totalRows = response.data.totalRows;
        return this.items || []
      }).catch((error) => {
        console.log(error);
        this.items = [];
        this.totalRows = 0;
        return this.items || []
      });
    },
    remove(id) {
      if (confirm("Удалить задачу #" + id + "?")) {
        this.error = false;
        this.axios.delete(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id, {}).then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.$refs.table.refresh()
            } else {
              console.log(response.data.message);
            }
          }
        })
      }
    },
    show(id) {
      this.isUpdate = true;
      this.error = false;
      this.form.id = id;
      this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/tasks/' + id, {})
        .then((response) => {
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.form = response.data.task;
              this.$bvModal.show('task-modal');
            } else {
              console.log(response.data.message);
            }
          }
        });
    },
    asyncFindResponsible(query) {
      this.isLoadingResponsible = true
      const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/users/?query=' + query);
      return promise.then(response => {
        this.optionsResponsible = response.data.users;
        this.isLoadingResponsible = false;
      }).catch((error) => {
        console.log(error);
        this.optionsResponsible = [];
        this.isLoadingResponsible = false;
      });
    },
  },
}
</script>

<style>
.hidden-overflow {
  overflow: hidden;
  white-space: pre-wrap;
}
</style>
